"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Cache = _interopRequireDefault(require("../Cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _Cache.default();

function getScrollOffset(selector, context) {
  return new Promise(function (resolve) {
    cache.getSelector(selector, context).scrollOffset().exec(function (ret) {
      resolve(ret[0]);
    });
  });
}

function getBoundingClientRect(selector, context) {
  return new Promise(function (resolve) {
    cache.getSelector(selector, context).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
}

var _default = {
  getScrollOffset: getScrollOffset,
  getBoundingClientRect: getBoundingClientRect
};
exports.default = _default;